__turbopack_context__.v({
  "location": "BrowseEventsInLocationSelector-module-scss-module__XtUHCW__location",
  "locationText": "BrowseEventsInLocationSelector-module-scss-module__XtUHCW__locationText",
});
